export default "__VITE_ASSET__zwnO$4Zh__"